export function bookDropDownToggler() {
    $(".book-button").on('click', function () {
        $(".book-drop-down-wrap").addClass('opened');
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/bookDropDownToggler.js